export const config = {
  AUTH_ROLE_TYPE: 'DeliveryOperationsPortal',
  AUTH_ROLES_ALLOWED: 'Admin,RegionalAreaManager,LocalAreaManager,Driver',
};

export const getConfig = (key = '') => config[key];

export default config;
